import { createApp } from 'vue'
import { createPinia } from 'pinia'
import router from './router'
import Toast from 'vue-toastification'
import App from './App.vue'
import { useBranding } from '@/composables/useBranding'

// CSS imports
import './assets/main.css'
import 'vue-toastification/dist/index.css'
import 'animate.css'

// Create Vue app
const app = createApp(App)

// Create Pinia store
const pinia = createPinia()

// Toast configuration for mobile
const toastOptions = {
  position: 'top-center',
  timeout: 3000,
  closeOnClick: true,
  pauseOnFocusLoss: true,
  pauseOnHover: false,
  draggable: true,
  draggablePercent: 0.6,
  showCloseButtonOnHover: false,
  hideProgressBar: false,
  closeButton: 'button',
  icon: true,
  rtl: false,
  transition: 'Vue-Toastification__slideBlurred',
  maxToasts: 3,
  newestOnTop: true,
  containerClassName: 'toast-container-mobile',
  toastClassName: 'toast-mobile',
  bodyClassName: 'toast-body-mobile'
}

// Use plugins
app.use(pinia)
app.use(router)
app.use(Toast, toastOptions)

// Error handling
app.config.errorHandler = (err, vm, info) => {
  console.error('Vue Error:', err)
  console.error('Vue Info:', info)
}

// Global properties for mobile detection
app.config.globalProperties.$isMobile = () => {
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)
}

app.config.globalProperties.$isIOS = () => {
  return /iPad|iPhone|iPod/.test(navigator.userAgent)
}

app.config.globalProperties.$isAndroid = () => {
  return /Android/.test(navigator.userAgent)
}

// Set dynamic document title
const branding = useBranding()
document.title = branding.metaTitle.value

// Mount the app
app.mount('#app')

// Initialize subscription listener after app is mounted and pinia is active
// Use nextTick to ensure Pinia is fully initialized
import { nextTick } from 'vue'
nextTick(() => {
  import('@/stores/subscription').then(({ useSubscriptionStore }) => {
    const subscriptionStore = useSubscriptionStore()
    subscriptionStore.initializeSubscriptionListener()
  })
})
